import React, { useState, useEffect } from 'react';
import { Tag, TagLabel, TagCloseButton, Input, Flex, FormControl, FormLabel } from '@chakra-ui/react';
import { inputDesign, inputStyles } from "../styles/theme"

const TagsInput = ({ formLabel, onTagsChange, initialTags = [] }) => {
  // Convert array of objects to array of strings for display
  const convertToStrings = (tagsArray) => {
    return tagsArray.map(obj => Object.keys(obj)[0]).filter(Boolean);
  };

  const convertToObjects = (stringsArray) => {
    return stringsArray.map(tag => ({ [tag]: 1 }));
  };

  const [tags, setTags] = useState(convertToStrings(initialTags));
  const [inputValue, setInputValue] = useState('');

  // Update internal tags when initialTags changes
  useEffect(() => {
    setTags(convertToStrings(initialTags));
  }, [initialTags]);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && inputValue.trim()) {
      event.preventDefault();
      const newTags = [...tags, inputValue.trim()];
      setTags(newTags);
      setInputValue('');
      
      // Convert to array of objects and notify parent
      if (onTagsChange) {
        onTagsChange(convertToObjects(newTags));
      }
    }
  };

  const removeTag = (index) => {
    const newTags = tags.filter((_, i) => i !== index);
    setTags(newTags);
    
    // Convert to array of objects and notify parent
    if (onTagsChange) {
      onTagsChange(convertToObjects(newTags));
    }
  };

  return (
    <FormControl sx={inputDesign.formStyles.container}>
      <Flex flexWrap="wrap" gap={2} alignItems="center">
        <Input
          id="tags-input-field"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder={tags.length === 0 ? '' : ''}
          sx={{ ...inputStyles, ...inputDesign.formStyles.input }}
          errorBorderColor="red.300"
        />
        <FormLabel
          htmlFor="tags-input-field"
          sx={inputDesign.formStyles.label}>
          {formLabel}
        </FormLabel>
        
        {/* Display existing tags */}
        <Flex flexWrap="wrap" gap={2} mt={2} width="100%">
          {tags.map((tag, index) => (
            <Tag size="lg" key={index} borderRadius="full" variant="solid" colorScheme="blue">
              <TagLabel>{tag}</TagLabel>
              <TagCloseButton onClick={() => removeTag(index)} />
            </Tag>
          ))}
        </Flex>
      </Flex>
    </FormControl>
  );
};

export default TagsInput;

// --------------------------------------------------------------------------------
// existing component code
// import React, { useState } from 'react';
// import { Tag, TagLabel, TagCloseButton, Input, Flex, FormControl, FormLabel } from '@chakra-ui/react';
// import {inputDesign , inputStyles} from "../styles/theme"

// const TagsInput = ({formLabel}) => {
//   const [tags, setTags] = useState([]);
//   const [inputValue, setInputValue] = useState('');

//   const handleKeyDown = (event) => {
//     if (event.key === 'Enter' && inputValue) {
//       event.preventDefault();
//       setTags([...tags, inputValue]);
//       setInputValue('');
//     }
//   };

//   const removeTag = (index) => {
//     setTags(tags.filter((_, i) => i !== index));
//   };


//   return (
//     <FormControl sx={inputDesign.formStyles.container}>
//       <Flex flexWrap="wrap" gap={2}>
//         <Input
//           id="tags-input-field"
//           value={inputValue}
//           onChange={(e) => setInputValue(e.target.value)}
//           onKeyDown={handleKeyDown}
//           placeholder={tags.length === 0 ? '' : ''}
//           sx={{ ...inputStyles, ...inputDesign.formStyles.input }}
//           errorBorderColor="red.300"
//         />
//         <FormLabel
//           htmlFor="tags-input-field"
//           sx={inputDesign.formStyles.label}>
//           {formLabel}
//         </FormLabel>
//         {tags.map((tag, index) => (
//           <Tag size="lg" key={index} borderRadius="full">
//             <TagLabel>{tag}</TagLabel>
//             <TagCloseButton onClick={() => removeTag(index)} />
//           </Tag>
//         ))}
//       </Flex>
//     </FormControl>
//   );
// };

// export default TagsInput;
